import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useLang } from "@/context/LanguageContext";

// ---------------------------------------------------------------------------
// Hell/Dunkel-Schalter — Sonne links, Mond rechts.
//
// Lag bis zum 04.08.2026 in Navbar.jsx und stand dort in der DESKTOP-Kopfzeile.
// Das ist er jetzt nicht mehr: Die Pille ist 96 px breit, und zusammen mit
// Sprachwähler, Nutzername und dem Primärknopf wurde die Zeile so eng, dass
// „Kostenlos inserieren" auf zwei Zeilen umbrach und die Abstände kippten.
// Ein Schalter, den man einmal einstellt und dann nie wieder anfasst, gehört
// nicht auf den teuersten Platz der Seite. Er steht jetzt im Fuß neben der
// Sprachwahl — dort, wo Einstellungen erwartet werden — und weiterhin im
// Mobilmenü, wo Platz ist.
//
// Fest LTR (Sonne links, Mond rechts): universelle Ikonografie, deckungsgleich
// mit der translateX-Richtung auch bei RTL (ar/he).
//
// `dunkel` invertiert die Farben für den dunklen Fußbereich: Dort steht die
// Pille auf Anthrazit, und die hellen Standardtöne verschwänden darin.
// ---------------------------------------------------------------------------
export default function ThemeToggle({ testId, wide = false, dunkel = false }) {
  const { setMode, isDark } = useTheme();
  const { t } = useLang();
  const rahmen = dunkel ? "border-white/20 bg-white/5" : "border-anthracite/10 bg-sand-deep/60";
  const daumen = dunkel ? "bg-white/15" : "bg-surface dark:bg-inkchip";
  const an = dunkel ? "text-white" : "text-mediterranean";
  const aus = dunkel ? "text-white/45" : "text-anthracite/45";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={t("theme.label")}
      title={t("theme.label")}
      data-testid={testId}
      dir="ltr"
      onClick={() => setMode(isDark ? "light" : "dark")}
      className={`relative grid grid-cols-2 items-stretch rounded-full border transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${rahmen} ${wide ? "w-full h-11" : "w-24 h-11"}`}
    >
      {/* Gleitender Daumen UNTER den Icons */}
      <span
        aria-hidden="true"
        className={`absolute top-[3px] bottom-[3px] left-[3px] w-[calc(50%-3px)] rounded-full ${daumen} shadow-[0_1px_4px_rgba(0,0,0,0.18)] transition-transform duration-200 ease-out ${isDark ? "translate-x-full" : "translate-x-0"}`}
      />
      <span className="relative flex items-center justify-center">
        <Sun className={`w-5 h-5 transition-colors duration-200 ${!isDark ? an : aus}`} strokeWidth={2.4} />
        <span className="sr-only">{t("theme.light")}</span>
      </span>
      <span className="relative flex items-center justify-center">
        <Moon className={`w-[18px] h-[18px] transition-colors duration-200 ${isDark ? an : aus}`} strokeWidth={2.4} />
        <span className="sr-only">{t("theme.dark")}</span>
      </span>
    </button>
  );
}
